export const getDynamicSearchAdPlacementStyles = () => ({
  placementCard: {
    background: 'white',
    borderRadius: '4px',
    boxShadow: '0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.10), 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13)',
    padding: '20px 16px',
    width: '482px',
  },
  placementTextCardContainer: {
    background: '#F5F5F5',
    minHeight: '200px',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placementTextContainer: {
    padding: '20px 10px 20px 20px',
    borderRadius: '8px',
    border: '1px solid #E1DFDD',
    background: 'white',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
    fontWeight: '400',
    width: '380px',
  },
  placementInlineItems: {
    display: 'inline-flex',
  },
  placementHeadline: {
    color: '#1A0DAB',
    fontSize: '18px',
    lineHeight: '22px',
  },
  placementDescriptionContainer: {
    display: 'inline-flex',
    alignItems: 'baseline',
  },
  placementDescription: {
    color: '#666',
    fontSize: '12px',
    lineHeight: '16px',
    wordBreak: 'break-word',
  },
  placementUrl: {
    color: '#006621',
    fontSize: '14px',
    lineHeight: '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  placementAdsLabel: {
    position: 'static !important',
    color: '#666 !important',
    border: '1px solid #ddd !important',
    borderRadius: '2px !important',
    fontSize: '11px !important',
    margin: '0 4px 0 0 !important',
    padding: '0 2px !important',
  },
  placementDisclaimer: {
    color: '#323130',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '20px',
    marginTop: '20px',
    textAlign: 'center',
  },
});
